import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MagezineDetail, Profile, ShowDetail } from '../../shared/interfaces/index.interface';
import { ErrorHandlingService, JwtService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class ShowDetailService implements OnInit{
  readonly BASE_URL = environment.BASE_API_URL;
  constructor(
    private http:HttpClient,
    private jwtService:JwtService,
    private errorHandlingService:ErrorHandlingService,
    private toastr:ToastrService
  ) { }
  ngOnInit(){ }
  getAuthor(username:string){
    return this.http.get<Profile>(`${this.BASE_URL}auth/users/${username}/`);
  }
  getMagezine(name:string | undefined,entity:string){
    if(entity == 'hamafarin') return this.http.get<any>(`${this.BASE_URL}auth/users/${name}/`); ;
    if(entity == 'katibe') return this.http.get<MagezineDetail>(`${this.BASE_URL}magazine/${name}/`);
    return this.http.get<MagezineDetail>(`${this.BASE_URL}magazine/${name}/`);   
  }
  getDetail(mag:string | undefined,postId:string | undefined,entity:string){
    if(entity == 'hamafarin') return this.http.get<any>(`${this.BASE_URL}post/${postId}/`); ;
    if(entity == 'katibe') return this.http.get<ShowDetail>(`${this.BASE_URL}post/${postId}/`);
    return this.http.get<ShowDetail>(`${this.BASE_URL}post/${postId}/`);
  }
  getRelatedPost(slug:any){
    return this.http.get(`${this.BASE_URL}post/${slug}/related_posts`);  
  }
}

